<div class="rounded-xl">
  <div class="flexable flex gap-2 p-2">
    <div
      class="flex gap-1 items-center rounded-tab w-fit p-2"
      *ngIf="isAllWarehouse"
    >
      <span class="text-black">Warehouse: </span>
      <div>
        <!-- <mat-form-field appearance="outline" class="rounded-form-field">
            <mat-label>Select Warehouse</mat-label>
            <mat-select [(ngModel)]="filtering.warehouse" (selectionChange)="onFilterChange(null, 'warehouse')">
                @for (warehouse of warehouses$ | async; track warehouse) {
                    <mat-option value="{{ warehouse?.uniqueId }}">{{ warehouse?.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field> -->
        <select
          name=""
          id=""
          [(ngModel)]="filtering.warehouse"
          (change)="onFilterChange(null, 'warehouse')"
        >
          <option value="" selected>All</option>
          @for (warehouse of warehouses$ | async; track warehouse) {
          <option value="{{ warehouse?.uniqueId }}">
            {{ warehouse?.name }}
          </option>
          }
        </select>
      </div>
    </div>
    <div
  class="flex gap-1 items-center rounded-tab w-fit p-2"
  *ngIf="filtering.warehouse"
>
  <span class="text-black">Sensor:</span>

  <select [(ngModel)]="filtering.sensor">
    <option value="">Select sensor</option>

    @for (sensor of warehouseSensors$ | async; track sensor) {
      <option [value]="sensor.uniqueId">
        {{ sensor.sensorName }}
      </option>
    }
  </select>

  <div *ngIf="filtering.sensor">
    <span
      (click)="filtering.sensor = null"
      class="pr-2.5 hover:bg-gray-300 cursor-pointer flex items-center rounded-full bg-gray-200 text-xs"
    >
      <mat-icon class="scale-50">clear</mat-icon> Clear
    </span>
  </div>
</div>

    <div class="flex gap-4 items-center rounded-tab w-fit p-2">
      <span class="text-black">Timeframe: </span>
      <div class="flex items-center gap-1">
        @for (tab of timeframeTabs; track tab) { @if (tab?.name ===
        activeTimeframeTab) {
        <span
          class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
        >
          <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
        </span>
        } @else {
        <!-- <mat-chip (click)="activeTimeframeTab = tab?.name; onFilterChange(tab?.name, 'timeframe')"
                          class="!cursor-pointer  !border !border-red !stroke-black">{{ tab?.name }}
                </mat-chip> -->
        <span
          (click)="
            activeTimeframeTab = tab?.name;
            onFilterChange(tab?.name, 'timeframe')
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
          >{{ tab?.name }}</span
        >
        } } @if (activeTimeframeTab) {
        <div
          (click)="
            activeTimeframeTab = null;
            filtering.dateTo = null;
            filtering.dateFrom = null
          "
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8] !w-fit flex !min-w-[132px] gap-1"
        >
          <fa-icon [icon]="faCalendar"></fa-icon>
          <span>Custom Date</span>
        </div>
        } @else {
        <span
          class="!cursor-pointer !bg-[#3A7AA8] !px-[12px] rounded-full !py-[8px] !min-w-[132px] gap-1"
        >
          <span class="text-white !text-[13px]">
            <fa-icon [icon]="faCalendar"></fa-icon>
            Custom Date
          </span>
        </span>
        }
        <div
          class="flex gap-1"
          [ngStyle]="{ display: activeTimeframeTab ? 'none' : '' }"
        >
          <div class="custom-date-input-container">
            <input
              type="text"
              class="custom-date-input"
              [max]="endDate"
              [(ngModel)]="startDate"
              (dateChange)="onFilterChange(null, 'dateFrom')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="startDatePicker"
              placeholder="Select Start Date"
              readonly
              (click)="startDatePicker.open()"
            />
            <button
              class="calendar-button"
              mat-icon-button
              [disabled]="activeTimeframeTab"
              (click)="startDatePicker.open()"
            >
              <img src="assets/icons/calendar-02.png" alt="" srcset="" />
            </button>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </div>
          <div class="custom-date-input-container">
            <input
              type="text"
              class="custom-date-input"
              [(ngModel)]="endDate"
              [min]="startDate"
              (dateChange)="onFilterChange(null, 'dateTo')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="endDatePicker"
              placeholder="Select End Date"
              readonly
              (click)="endDatePicker.open()"
            />
            <button
              class="calendar-button"
              mat-icon-button
              [disabled]="activeTimeframeTab"
              (click)="endDatePicker.open()"
            >
              <img src="assets/icons/calendar-02.png" alt="" srcset="" />
            </button>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </div>
          <!-- <mat-form-field appearance="outline" class="w-full">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [(ngModel)]="endDate"
              [min]="startDate"
              (dateChange)="onFilterChange(null, 'dateTo')"
              [disabled]="activeTimeframeTab"
              [matDatepicker]="endDatePicker"
              placeholder="Select End Date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field> -->
        </div>
      </div>
    </div>

    <div class="flex gap-4 items-center rounded-tab w-fit p-2">
      <span class="text-black">Frequency: </span>
      <div class="flex gap-1">
        @for (tab of frequencyTabs; track tab) { @if (tab?.name ===
        activeFrequencyTab) {
        <span
          class="!bg-[#3A7AA8] !text-white !px-[12px] rounded-full !py-[8px]"
        >
          <span class="text-white text-[13px] relative">{{ tab?.name }}</span>
        </span>
        } @else {
        <span
          class="!cursor-pointer !border border-[#3A7AA8] px-[12px] py-[8px] rounded-full text-[#3A7AA8]"
          (click)="
            activeFrequencyTab = tab?.name;
            onFilterChange(tab?.name, 'timeRange')
          "
          >{{ tab?.name }}
        </span>
        } }
      </div>
    </div>
  </div>

  <div class="flex justify-center pb-2">
    <button
      (click)="generateReport()"
      class="rounded-full py-[8px] px-[12px] flex gap-2 text-[13px] font-normal !bg-[#025590] !text-white">
      Generate
    </button>
    <!-- <button (click)="generatePDF()" color="warn" [disabled]="!reportData" mat-raised-button class="ml-2"> -->
    <!--     <mat-icon>picture_as_pdf</mat-icon> -->
    <!--     Generate PDF -->
    <!-- </button> -->
  </div>
</div>

@if (reportData) {
<!-- <div class="flex justify-between items-center px-8 border-t pt-6 mt-4"> -->
<!---->
<!--     <img src="/assets/images/emblem.png" class="w-24"> -->
<!---->
<!--     <div class="flex flex-col gap-1 items-center"> -->
<!--         <span class="font-bold text-2xl text-[#005590]">The United Republic of Tanzania</span> -->
<!--         <span class="font-bold text-xl text-[#005590]">Medical Store Department</span> -->
<!--         <span class="font-bold text-[#005590]"> -->
<!-- </span> -->
<!--     </div> -->
<!---->
<!--     <img src="/assets/images/logo.svg" class="h-full"> -->
<!---->
<!-- </div> -->

<app-pdf-viewer
  *ngIf="reportData"
  class="w-full"
  [base64Src]="reportData"
  [filenameForDownload]="'title'"
></app-pdf-viewer>

<!-- <div class="flex flex-col gap-12 mt-12"> -->
<!--     @for (zone of reportData?.records; track zone) { -->
<!--         <div class=""> -->
<!--             <div class="ml-4 flex flex-col items-start justify-center mb-2 text-secondary-600"> -->
<!--         <span class="font-bold"> -->
<!--             {{ $index + 1 }}. {{ zone?.zone_name?.toUpperCase() }} -->
<!--         </span> -->
<!--             </div> -->
<!---->
<!--             <div class="w-full overflow-x-scroll"> -->
<!--                 <table class="w-full"> -->
<!--                     <thead> -->
<!--                     <!--                    <th class="th bg-secondary text-white">Building Zones</th>-->
-->
<!--                     <th class="th bg-secondary  text-white">Sensors</th> -->
<!--                         @for (column of reportData?.dates_labels; track column) { -->
<!--                             <th class="th bg-secondary text-white">{{ column }}</th> -->
<!--                         } -->
<!--                     </thead> -->
<!---->
<!--                     <tbody> -->
<!--                         @for (sensor of zone?.all_sensors; track sensor) { -->
<!--                             <tr class="bg-primary-50"> -->
<!--                                 <!--                        <td [attr.rowspan]="zone?.zones[0]?.sensors?.length" class="td">{{ zone?.zones[0]?.name }}</td>-->
-->
<!---->
<!--                                 <td class="td">{{ sensor.sensor_serial }}</td> -->
<!---->
<!--                                 @for (data of sensor?.all_data; track data) { -->
<!--                                     <td class="td"> -->
<!--                                         <div class="flex gap-3"> -->
<!--                                     <span class="flex gap-1"> -->
<!--                                         <fa-icon [icon]="faTemperature2"></fa-icon> -->
<!--                                         {{ data?.avg_temperature | round : 2 }}&deg;C -->
<!--                                     </span> -->
<!--                                             <span class="flex gap-1"> -->
<!--                                         <fa-icon [icon]="faDroplet"></fa-icon> -->
<!--                                                 {{ data?.avg_humidity | round : 2 }}% -->
<!--                                     </span> -->
<!--                                         </div> -->
<!--                                     </td> -->
<!--                                 } -->
<!--                             </tr> -->
<!--                         } -->
<!--                     </tbody> -->
<!--                 </table> -->
<!--             </div> -->
<!--         </div> -->
<!--     } -->
<!-- </div> -->
}
